import { Component, Input } from '@angular/core';

import { DataAccessScreensizeFacade, SliderConfig } from '@planone/bau365/data-access-screensize';
import { Event, Exhibitor } from '@planone/bau365/util-fair-data';
import { stringifyFilter } from '@planone/shared/util-interfaces';
import { Observable } from 'rxjs';

@Component({
  selector: 'bau365-event-section-entity-list',
  templateUrl: './section-entity-list.component.html',
  styleUrls: ['./section-entity-list.component.scss'],
})
export class SectionEntityListComponent {
  @Input() eventList?: Event[];
  @Input() exhibitor?: Exhibitor;

  size$: Observable<string | undefined>;
  cardSliderConfig$: Observable<SliderConfig | null | undefined>;

  stringifyFilter = stringifyFilter;

  constructor(private ScreensizeFacade: DataAccessScreensizeFacade) {
    this.size$ = ScreensizeFacade.size$;
    this.cardSliderConfig$ = ScreensizeFacade.cardSliderConfig$;
  }
}
